module.exports = __webpack_public_path__ + "img/company_09.95ff98d8.png";